import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg width="61.459" height="67.843" viewBox="0 0 61.459 67.843">
    <g id="trash" transform="translate(-2.5 -1)">
      <path
        id="Caminho_245"
        data-name="Caminho 245"
        d="M4.5,9H61.959"
        transform="translate(0 6.769)"
        fill="none"
        stroke="#73f6f9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        id="Caminho_246"
        data-name="Caminho 246"
        d="M52.19,15.769v44.69a6.384,6.384,0,0,1-6.384,6.384H13.884A6.384,6.384,0,0,1,7.5,60.459V15.769m9.576,0V9.384A6.384,6.384,0,0,1,23.461,3H36.229a6.384,6.384,0,0,1,6.384,6.384v6.384"
        transform="translate(3.384)"
        fill="none"
        stroke="#73f6f9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        id="Caminho_247"
        data-name="Caminho 247"
        d="M15,16.5V35.653"
        transform="translate(11.845 15.229)"
        fill="none"
        stroke="#73f6f9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        id="Caminho_248"
        data-name="Caminho 248"
        d="M21,16.5V35.653"
        transform="translate(18.614 15.229)"
        fill="none"
        stroke="#73f6f9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
    </g>
  </svg>,
  'TrashIcon',
);
